import { cn } from '../../utils';

export type AllRightsReservedFooterProps = {
  /**
   * Override the brand name in the footer text.
   * Defaults to "English2Empower".
   */
  brandName?: string;
  /**
   * Override the year that gets rendered (useful for testing).
   * Defaults to the current calendar year.
   */
  year?: number;
  /**
   * Optional className to customize the outer footer container.
   */
  className?: string;
};

export function AllRightsReservedFooter({
  brandName = 'English2Empower',
  year = new Date().getFullYear(),
  className,
}: AllRightsReservedFooterProps) {
  return (
    <footer
      className={cn(
        'border-t border-rose-100/70 bg-transparent px-4 py-6 text-center text-xs text-slate-500',
        className,
      )}
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4">
        <img
          src="/logo-small.png"
          alt={brandName}
          className="h-[40px] w-auto object-contain"
        />
        <p>&copy; {year} {brandName}. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default AllRightsReservedFooter;

